<template>
  <div class="cont">
    <div class="banner">
      <div
        style="width: 1200px;margin: 0px auto;position: relative;display: flex;justify-content: space-between;align-items: center;">
        <p class="top-title">个人中心</p>
        <el-dropdown v-if="$store.state.name" @command="handleCommand" class="userMenu">
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;">个人中心</span>
            <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix" command="Personal">
              {{ $store.state.name }}
            </el-dropdown-item>
            <el-dropdown-item class="clearfix" command="LoginOut">
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-else trigger="click" class="userMenu" disabled>
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;" @click="toWeiXinLogin">登录</span>
            <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
          </div>
        </el-dropdown>
      </div>
    </div>
    <div class="row_menu">
      <div class="row_menu_item row_menu_item_active">基本信息</div>
      <div class="row_menu_item" @click="toMyOfffice">我的办件</div>
      <!-- <div class="row_menu_item" @click="toMyMaterials">我的材料</div> -->
    </div>
    <div class="form_box" v-loading="loading">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
        class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="sex">
              <el-select style="width: 100%;" v-model="ruleForm.sex" placeholder="请选择性别" disabled>
                <el-option label="女" :value="1"></el-option>
                <el-option label="男" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="身份证号码" prop="idCard">
              <el-input v-model="ruleForm.idCard" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="电话号码" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 上传 -->
        <!-- <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="请上传你的二代身份证" label-width="200px" prop="frontUrl">
              <el-upload class="avatar-uploader" style="width:240px" :action="action" accept=".jpg, .jpeg, .png"
                list-type="picture-card" :show-file-list="false" :on-success="handleFrontUrlSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="ruleForm.frontUrl" :src="ruleForm.frontUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-show="!ruleForm.frontUrl" class="el-upload__tip" slot="tip">上传人像面</div>
                <span style="width:240px" v-show="ruleForm.frontUrl" class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click.stop="handlePictureCardPreview(ruleForm.frontUrl, 0)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click.stop="handleRemove(ruleForm.frontUrl, 0)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>

            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="reverseUrl">
              <el-upload class="avatar-uploader" style="width:240px" accept=".jpg, .jpeg, .png" :action="action"
                list-type="picture-card" :show-file-list="false" :on-success="handleReverseUrlSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="ruleForm.reverseUrl" :src="ruleForm.reverseUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-show="!ruleForm.reverseUrl" class="el-upload__tip" slot="tip">上传国徽面</div>
                <span style="width:240px" v-show="ruleForm.reverseUrl" class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview"
                    @click.stop="handlePictureCardPreview(ruleForm.reverseUrl, 1)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click.stop="handleRemove(ruleForm.sreverseUrl, 1)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
            </el-form-item>
          </el-col>

        </el-row> -->
        <el-form-item class="submit_box">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { updateUser, logout } from '@/api/user/index'

export default {
  name: 'Personal',
  data() {
    return {
      ruleForm: {
        userId: this.$store.state.userId,
        name: this.$store.state.name,
        sex: this.$store.state.sex,
        idCard: this.$store.state.idCard,
        phone: this.$store.state.phone,
        frontUrl: this.$store.state.frontUrl,
        reverseUrl: this.$store.state.reverseUrl,
      },
      loading: false,
      disabled: false,
      dialogVisible: false,
      dialogImageUrl: '',
      action: 'http://182.140.209.211:20021/zwmap/uploadMaterialFile',//上传接口地址
      rules: {
        name: [
          { required: true, message: '请输入你的真实姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        idCard: [
          { required: true, message: '请输入你的身份证号码', trigger: 'blur' },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "请输入正确的身份证号码",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: '请输入你的电话号码', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        // frontUrl: [
        //   { required: true, message: '请上传你的身份证正面照片', trigger: 'blur' },
        // ],
        // reverseUrl: [
        //   { required: true, message: '请上传你的身份证反面照片', trigger: 'blur' },
        // ],
      }
    };
  },

  mounted() {
  },

  methods: {
    // 身份证正面上传成功钩子函数
    handleFrontUrlSuccess(response, file, fileList) {
      this.ruleForm.frontUrl = response.url;
      console.log(response, file, fileList, '上传成功')
    },
    // 身份证反面上传成功钩子函数
    handleReverseUrlSuccess(response, file, fileList) {
      this.ruleForm.reverseUrl = response.url;
      console.log(response, file, fileList, '上传成功')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return (isJPG || isPNG) && isLt5M;
    },
    handleRemove(fileUrl, type) {
      console.log(fileUrl, type);
      if (type == 0) {
        this.ruleForm.frontUrl = '';
      } else {
        this.ruleForm.reverseUrl = '';
      }
    },
    handlePictureCardPreview(fileUrl, type) {
      console.log(fileUrl)
      this.dialogImageUrl = fileUrl;
      this.dialogVisible = true;
    },
    // 表单上传
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let obj = this.ruleForm;
          updateUser(obj).then(res => {
            console.log(res, '修改用户信息结果')
            if (res.data.code == 200) {
              this.$message.success('用户信息修改成功')
              localStorage.setItem('userInfo', JSON.stringify(res.data.data));
              this.$store.commit('SET_USERID', res.data.data.userId);
              this.$store.commit('SET_NAME', res.data.data.name);
              this.$store.commit('SET_SEX', res.data.data.sex);
              this.$store.commit('SET_IDCARD', res.data.data.idCard);
              this.$store.commit('SET_PHONE', res.data.data.phone);
              this.$store.commit('SET_REVERSERUL', res.data.data.reverseUrl);
              this.$store.commit('SET_FRONTURL', res.data.data.frontUrl);
              this.loading = false;
              this.$router.go(0)
            } else if (res.data.code == 1001) {
              this.$message.error('登录状态已过期，请重新登录！')
              this.loading = false;
              localStorage.removeItem('userInfo');
              localStorage.removeItem('token');
              sessionStorage.removeItem('applyId');
              this.$router.push('/')
            } else {
              this.loading = false;
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 表单重置
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.ruleForm.phone = '';
      this.ruleForm.frontUrl = '';
      this.ruleForm.reverseUrl = '';
    },
    toMyOfffice() {
      this.$router.push({ name: 'MyOffice' })
    },
    toMyMaterials() {
      this.$router.push({ name: 'MyMaterials' })
    },
    // 用户下拉菜单
    handleCommand(name) {
      switch (name) {
        case 'Personal':
          this.$router.push({
            name: 'Personal'
          })
          break;
        case 'LoginOut':
          this.LoginOut()
          break;
      }
    },
    // 到微信登录
    toWeiXinLogin() {
      this.$router.push({
        name: "WeiXinLogin",
        replace: true,
      });
    },
    // 退出登录
    LoginOut() {
      let params = {
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
        token: localStorage.getItem('token').toString(),
      }
      logout(params).then((res) => {
        // console.log('退出登录结果：', res)
        if (res.data.code == 200) {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        } else if (res.data.code == 1001) {
          this.$message.error('登录状态已过期，请重新登录！')
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        }
        else {
          this.$message.error('退出登录失败！')
        }
      })
    },
  },
};
</script>
<style scoped>
.cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
}

.banner {
  background-size: 100% auto;
  position: absolute;
  top: 150px;
}

.top-title {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
}

.userMenu {
  position: initial;
}

.form_box {
  /* width: 900px; */
  margin: 0 auto;
  /* padding: 40px 0; */
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: auto;
  display: block;
}

.el-upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.el-upload-list__item-actions:hover {
  opacity: 1;
}

.el-upload-list__item-actions:hover span {
  display: inline-block;
}

.el-upload-list__item-actions span {
  cursor: pointer;
}

.el-icon-zoom-in,
.el-icon-delete {
  color: #fff;
}

.el-upload-list__item-delete {
  position: initial;
}

.row_menu {
  display: flex;
  justify-content: flex-start;
  height: 40px;
  border-bottom: 2px solid #e4e7ed;
  align-items: center;
  margin-bottom: 30px;
}

.row_menu_item_active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.row_menu_item {
  width: 100px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  font-weight: bold;
}
.row_menu_item:hover{
  color: #409eff;
}
.submit_box {
  margin-left: 100px;
  width: 65%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
</style>